import React from 'react';
import { COLORS } from 'Permafrost/index';
import { StyledPercentageRing } from './PercentageRing.styles';
export function PercentageRing(props) {
    const { backgroundColor = COLORS.clay, className, foregroundColor = COLORS.baliHai, id, ringRadius = 35, strokeWidth = 5, value = 0, valueFontSize = 20, } = props;
    const ringCircumference = 2 * Math.PI * (ringRadius - strokeWidth / 2);
    const valueCircumference = ringCircumference - value * ringCircumference;
    const diameter = ringRadius * 2;
    const circleRadius = ringRadius - strokeWidth / 2;
    // ensure we don’t display a value greater than 100% to the user
    const displayValue = Math.round(Math.min(value, 1) * 100);
    return (React.createElement(StyledPercentageRing, { className: className, "data-cy": props['data-cy'], id: id },
        React.createElement("div", { style: {
                fontSize: valueFontSize,
                width: diameter,
                height: diameter,
            } },
            displayValue,
            React.createElement("span", null, "%")),
        React.createElement("svg", { height: diameter, width: diameter, fill: "none", strokeWidth: strokeWidth, "aria-hidden": "true", focusable: "false" },
            React.createElement("g", null,
                React.createElement("circle", { r: circleRadius, cx: ringRadius, cy: ringRadius, stroke: backgroundColor }),
                React.createElement("circle", { r: circleRadius, cx: ringRadius, cy: ringRadius, stroke: foregroundColor, strokeDasharray: ringCircumference, strokeDashoffset: valueCircumference })))));
}
//# sourceMappingURL=PercentageRing.js.map